import { Component, Input } from '@angular/core';
import { IOrderSummary } from '../../interfaces/order-summary.interface';
import { CommonInfoService } from '../../cart-process/common-info.service';

@Component({
  selector: '[order-summary-what-happen-now]',
  templateUrl: './order-summary-what-happen-now.component.html',
})
export class OrderSummaryWhatHappenNowComponent {
  @Input() public whatHappensNow: IOrderSummary.WhatHappensNow;
  @Input() public orderData: IOrderSummary.Root;

  constructor(
    public commonInfo: CommonInfoService,
  ) {
  }
}
